/**
 * Role Toggle Component
 * Allows switching between admin and participant roles for testing
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './RoleToggle.css';

const RoleToggle = () => {
  // Hidden - View All Apps button provides same functionality
  return null;
};

export default RoleToggle;
